import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { useAddEvidenceLinkMutation, useDelEvidenceLinkMutation, useListEvidenceLinksQuery, useUpdateEvidenceLinkMutation } from '~/types/types';
import { mergeArrays } from '~/functions/helpers';
export default /*#__PURE__*/_defineComponent({
  __name: 'EvidenceLink',
  props: {
    query: Object
  },
  setup: function setup(__props) {
    var props = __props;
    var attrs = useAttrs();
    var readOnly = computed(function () {
      return Boolean(attrs.readonly || attrs.readOnly);
    });
    var descriptionHeader = computed(function () {
      var _attrs$headers;
      return (attrs === null || attrs === void 0 ? void 0 : (_attrs$headers = attrs.headers) === null || _attrs$headers === void 0 ? void 0 : _attrs$headers.find(function (v) {
        return (v === null || v === void 0 ? void 0 : v.value) === 'description';
      }).text) || 'Item';
    });
    var headers = computed(function () {
      var old = [{
        value: 'actions',
        cellClass: 'max-w-[20px]',
        width: '10px'
      }, {
        value: 'id',
        sortable: false
      }, {
        value: 'description',
        width: '80%'
      }, {
        value: 'evidence',
        width: '100px'
      }];
      // Overriding the attributes by key.
      // Can use ['actions', 'id'] OR
      // Can use [{ value: 'actions' }, { value: 'id' }]
      var x = mergeArrays(old, (attrs === null || attrs === void 0 ? void 0 : attrs.headers) || []);
      return _toConsumableArray(x).filter(function (o) {
        var _attrs$headers2;
        return attrs === null || attrs === void 0 ? void 0 : (_attrs$headers2 = attrs.headers) === null || _attrs$headers2 === void 0 ? void 0 : _attrs$headers2.map(function (h) {
          return h.value || h;
        }).includes(o.value);
      }).map(function (col) {
        return _objectSpread(_objectSpread({}, col), {}, {
          sortable: col.sortable || false
        });
      }) || [];
    });
    var options = ref({
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    });
    var search = ref('');
    var variables = computed(function () {
      return {
        filters: _objectSpread({}, props.query),
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage
      };
    });
    var _useListEvidenceLinks = useListEvidenceLinksQuery(variables, {
        fetchPolicy: 'network-only'
      }),
      result = _useListEvidenceLinks.result,
      refetch = _useListEvidenceLinks.refetch,
      loading = _useListEvidenceLinks.loading,
      networkStatus = _useListEvidenceLinks.networkStatus;
    var items = computed(function () {
      var _result$value$listEvi, _result$value;
      return (_result$value$listEvi = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listEvidenceLinks) !== null && _result$value$listEvi !== void 0 ? _result$value$listEvi : [];
    });
    var itemCount = computed(function () {
      var _result$value2;
      return (result === null || result === void 0 ? void 0 : (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countEvidenceLinks) || 0;
    });
    var _useUpdateEvidenceLin = useUpdateEvidenceLinkMutation(),
      updateEvidenceLink = _useUpdateEvidenceLin.mutate,
      onDone = _useUpdateEvidenceLin.onDone;
    var _useDelEvidenceLinkMu = useDelEvidenceLinkMutation(),
      delEvidenceLink = _useDelEvidenceLinkMu.mutate;
    var _useAddEvidenceLinkMu = useAddEvidenceLinkMutation(),
      addEvidenceLink = _useAddEvidenceLinkMu.mutate;
    onDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    function getEvidenceInternalUrl(item) {
      return item && item.evidence && item.evidence.internalUrl ? item.evidence.internalUrl : '';
    }
    function getEvidenceFilename(item) {
      return item && item.evidence && item.evidence.filename ? item.evidence.filename : '';
    }
    function getEvidenceWebsiteUrl(item) {
      return item && item.evidence && item.evidence.websiteUrl ? item.evidence.websiteUrl : '';
    }
    var handleDelete = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(id, dialog) {
        var _result$data;
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return delEvidenceLink({
                id: id
              });
            case 2:
              result = _context.sent;
              if ((result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.delEvidenceLink) === false) {
                window.$nuxt.$emit('userError', {
                  color: 'red',
                  message: 'Unable to delete evidence link created by another account.'
                });
                dialog.value = false;
              } else {
                refetch();
                dialog.value = false;
                window.$nuxt.$emit('userMsg');
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleDelete(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      attrs: attrs,
      props: props,
      readOnly: readOnly,
      descriptionHeader: descriptionHeader,
      headers: headers,
      options: options,
      search: search,
      variables: variables,
      result: result,
      refetch: refetch,
      loading: loading,
      networkStatus: networkStatus,
      items: items,
      itemCount: itemCount,
      updateEvidenceLink: updateEvidenceLink,
      onDone: onDone,
      delEvidenceLink: delEvidenceLink,
      addEvidenceLink: addEvidenceLink,
      getEvidenceInternalUrl: getEvidenceInternalUrl,
      getEvidenceFilename: getEvidenceFilename,
      getEvidenceWebsiteUrl: getEvidenceWebsiteUrl,
      handleDelete: handleDelete
    };
  }
});